<template>
  <div class="chart-container">
    <loading v-if="isLoading" />

    <v-select
      class="year-select"
      :items="anoLectivoAll"
      v-model="anoLectivoSelected"
      @change="carregarDados"
      item-value="descricao"
      item-text="novadescricao"
      label="Ano Lectivo"
      outlined
      dense
      hide-details
    ></v-select>

    <bar-chart v-if="!isLoading && chartData" :chart-data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import axios from "../../../plugins/axios"
const ls = require('local-storage')

export default {
  name: 'DistribuicaoNotas',
  components: {
    loading: () => import("../../../components/loading.vue"),
    'bar-chart': {
      extends: Bar,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        }
      }
    }
  },
  data() {
    return {
      anoLectivoAll: [],
      anoLectivoSelected: ls.get('anolectivo'),
      isLoading: false,
      mediaAll: [],
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Distribuição de Notas por Faixa'
        },
        scales: {
          yAxes: [{
            ticks: { beginAtZero: true },
            scaleLabel: {
              display: true,
              labelString: 'Total de Estudantes'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Faixa de Notas'
            }
          }]
        }
      }
    }
  },

  async created() {
    await this.carregarAnosLectivos()
    await this.carregarDados()
  },

  methods: {
    async carregarAnosLectivos() {
      this.isLoading = true
      try {
        const response = await axios.get(`/getAnosLectivosAll`)
        this.anoLectivoAll = response.data
      } catch (error) {
        console.error("Erro ao carregar anos lectivos:", error)
      } finally {
        this.isLoading = false
      }
    },

    async carregarDados() {
      this.isLoading = true
      try {
        const anolectivo = this.anoLectivoSelected || ls.get('anolectivo')
        const response = await axios.get(`/distribuicaoPorFaixa/${anolectivo}`)
        this.mediaAll = response.data

        this.chartData = {
          labels: this.mediaAll.map(item => item.faixa),
          datasets: [{
            label: 'Total de Estudantes',
            backgroundColor: '#42A5F5',
            data: this.mediaAll.map(item => item.total)
          }]
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
}
.year-select {
  margin-bottom: 20px;
}
</style>
